import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTable, { fmtCurrency, fmtDate } from "../components/DataTable";
import { apiCall } from "../auth/AuthContext";

export default function AdminTradelines() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterReported, setFilterReported] = useState("all");

  useEffect(() => {
    (async () => {
      try { const d = await apiCall("/api/admin/tradelines"); setRecords(d.records || []); }
      catch { setRecords([]); }
      finally { setLoading(false); }
    })();
  }, []);

  const filtered = records.filter((r) => {
    if (filterReported === "reported") return r.Reported === true;
    if (filterReported === "pending") return !r.Reported;
    return true;
  });

  const columns = [
    { key: "Name", label: "Client", sortable: true },
    { key: "Tradeline Name", label: "Tradeline" },
    { key: "Credit Limit", label: "Limit", fmt: fmtCurrency },
    { key: "Reporting Date", label: "Reports", fmt: fmtDate, sortable: true },
    {
      key: "Days Until Reporting", label: "Days",
      fmt: (v) => typeof v === "number" ? (
        <span className={v < 7 && v >= 0 ? "text-amber-300 font-semibold" : v < 0 ? "text-red-300" : "text-jc-white"}>{v}</span>
      ) : "—"
    },
    { key: "Bureaus Reporting", label: "Bureaus", fmt: (v) => Array.isArray(v) ? v.join(", ") : (v || "—") },
    {
      key: "Reported", label: "Reported?",
      fmt: (v) => v ? <span className="text-emerald-300">✓</span> : <span className="text-jc-muted">—</span>
    },
  ];

  return (
    <AdminLayout title="TRADELINE TRACKER" kicker="Reporting Timeline">
      <div className="flex gap-2 mb-5">
        {[
          ["all", "All"],
          ["pending", "Pending"],
          ["reported", "Reported"],
        ].map(([k, l]) => (
          <button
            key={k}
            onClick={() => setFilterReported(k)}
            data-testid={`tradeline-filter-${k}`}
            className={`px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] border transition-colors ${
              filterReported === k ? "bg-jc-gold text-jc-black border-jc-gold" : "border-jc-gold/30 text-jc-muted hover:text-jc-white hover:border-jc-gold/70"
            }`}
          >{l}</button>
        ))}
      </div>

      <DataTable
        testId="admin-tradelines-table"
        loading={loading}
        records={filtered}
        columns={columns}
        searchKeys={["Name", "Tradeline Name"]}
        emptyText="No tradelines yet."
        initialSort={{ key: "Reporting Date", dir: "asc" }}
      />
    </AdminLayout>
  );
}
